import {
    HistoryChangeAction,
    HistoryChangeType,
    LocationChangeAction,
    LocationChangeType,
    ScrollToActionType,
    SystemConfirmType,
} from '@web/actions/application'
import {MobileAppType, ScrollType, ScrollTypeType} from '@web/core/constants'
import {NAVER_CAFE_CLOSE} from '@web/core/urls'
import {
    changeBrowserLocation,
    goBack,
    goBackAndClose,
    goBackOrFallbackPage,
    openNewTab,
    reloadBrowserLocation,
} from '@web/helpers/browser'

export const scrollToEvent = (payload: ScrollToActionType) => {
    const {scrollType, customScrollBody} = payload
    // customScrollBody가 없으면 window가 scrollBody
    const scrollBody = customScrollBody ?? window

    if (scrollType === ScrollType.MOVE) {
        const {top = 0, left = 0} = payload
        scrollBody.scrollTo({top, left})
        return
    }

    if (scrollType === ScrollType.SELECTOR) {
        const {selectTarget, options} = payload
        const scrollTarget = customScrollBody
            ? customScrollBody.querySelector(selectTarget)
            : window.document.querySelector(selectTarget)

        scrollTarget?.scrollIntoView(options)
    }

    const edgeScrollTypes: ScrollTypeType[] = [ScrollType.TOP, ScrollType.BOTTOM]
    if (edgeScrollTypes.includes(scrollType)) {
        scrollBody.scrollTo(
            0,
            scrollType === ScrollType.TOP
                ? 0
                : customScrollBody
                  ? customScrollBody.scrollHeight
                  : document.body.scrollHeight,
        )
    }
}

/**
 * 네이티브 앱별 닫기 동작을 정의하는 Scheme
 * - TODO: 추후 페이앱외 앱들에 대한 호환성도 확대해야 합니다.
 */
const closeAppScheme: Record<MobileAppType, string> = {
    /** 네이버 치지직 */
    CHZZK: '',
    /** 네이버 앱 */
    NAVER: '',
    /** 네이버 카페앱 */
    NAVER_CAFE: NAVER_CAFE_CLOSE,
    /** 네이버 지도앱 */
    NAVER_MAP: '',
    /** 네이버 페이앱 */
    NAVER_PAY: 'naverapp://closewindow',
    /** 네이버 쇼핑앱 */
    NAVER_SHOPPING: '',
    /** 네이버 웹툰앱 */
    NAVER_WEBTOON: '',
    /** 네이버 시리즈앱 */
    SERIES: '',
    /** 네이버 바이브앱 */
    VIBE: '',
    /** 식별할 수 없는 앱 */
    UNKNOWN: '',
}

export const locationChangeEvent = (payload: LocationChangeType) => {
    if (payload.message) {
        window.alert(payload.message)
    }
    switch (payload.type) {
        case LocationChangeAction.PUSH:
            changeBrowserLocation({
                url: payload.url,
                type: 'PUSH',
                preserveCircularHistory: payload.shouldBack === 'SAME',
            })
            break
        case LocationChangeAction.REPLACE:
            changeBrowserLocation({
                url: payload.url,
                type: 'REPLACE',
                preserveCircularHistory: payload.shouldBack === 'SAME',
            })
            break
        case LocationChangeAction.BACK:
            if (payload.fallbackUrl) {
                goBackOrFallbackPage(payload.fallbackUrl, payload.steps)
            } else if (payload.close) {
                goBackAndClose(payload.steps)
            } else {
                goBack({steps: payload.steps})
            }
            break
        case LocationChangeAction.NEW_TAB:
            openNewTab({url: payload.url})
            break
        case LocationChangeAction.RELOAD:
            reloadBrowserLocation()
            break
        case LocationChangeAction.CLOSE:
            if (payload.appType && closeAppScheme[payload.appType]) {
                window.location.href = closeAppScheme[payload.appType]
            } else {
                window.self.close()
            }
            break
    }
}

export const delayedLocationChangeEvent = (payload: LocationChangeType) => {
    window.requestAnimationFrame(function () {
        locationChangeEvent(payload)
    })
}

export const historyChangeEvent = (payload: HistoryChangeType) => {
    switch (payload.type) {
        case HistoryChangeAction.REMOVE_QUERY:
            window.history.replaceState({}, '', window.location.pathname)
            break
        case HistoryChangeAction.REPLACE_QUERY:
            window.history.replaceState({}, '', payload.url)
            break
        case HistoryChangeAction.REPLACE_STATE:
            window.history.replaceState(payload.state, '', window.location.href)
            break
    }
}

export const systemConfirmEvent = (payload: SystemConfirmType) => {
    const result = confirm(payload.message)
    payload.callback?.(result)
}
